export { default } from './ownerWindow';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerWindow/index.js
// module id = 833
// module chunks = 25